<template>
    <div style="width: 200px;">
        <h2>Line Login....</h2>
    </div>
    
</template>
<script>
//import axios from 'axios';
//import qs from 'qs'
export default{
    name: "LineLogin",
    data(){
        return{
            email:null,
            name:null,
            Url:null
        }
    },
    async created(){
        let search = window.location.search;
        /*分析:最前面為?或是&，緊跟著除?&#以外的字符,=後面再跟著除?&#以外的字符*/
        var reg =/[?&]([^?&#]+)=([^?&#]+)/g;
        var par = {};
        var ret = reg.exec(search);
        while(ret){
            par[ret[1]]=ret[2];
            ret = reg.exec(search);
        }
        let code = par['code'];
        let state = par['state'];
        //let error = par['error'];

        // if(error == "ACCESS_DENIED"){
        //     alert("您好，必須允許存取Line的權限，才能使用Line功能");
        // }

        if(state === "login"){
            let res =await this.userRequest.post("/API/Line/GetLineLogin",{code:code,state:state});
            let json = JSON.parse(res.data);
            console.log(json);
            if(json.Status){
                let jsondata = JSON.parse(json.Data);
                if(jsondata.ISLINELOGIN == 1){
                    sessionStorage.setItem("isLine",true);
                }
                sessionStorage.setItem("TokenID", jsondata.tokenid);
                sessionStorage.setItem("username", jsondata.username);
                sessionStorage.setItem("lineUserid",jsondata.lineuserid);
                if(jsondata.AC_GETGIFT != null) sessionStorage.setItem("getGift", jsondata.AC_GETGIFT);
                if(jsondata.AC_GOOGLEFROM =="true") sessionStorage.setItem("GoogleFrom",true);
                
                console.log(['jsondata',jsondata,jsondata.AC_FIRST_SUBSCRIPTION == 1])
                //登入成功轉跳
                //如果已經做過第一次訂閱，則將頁面轉跳至我的專區
                if(jsondata.AC_FIRST_SUBSCRIPTION == 1){
                    window.location.assign("https://agri-data.cyhg.gov.tw/#/myprefecture/");
                    //window.location.assign("http://localhost:8080/#/myprefecture/");
                }
                else{
                    window.location.assign("https://agri-data.cyhg.gov.tw/#/subscription/");
                    //window.location.assign("http://localhost:8080/#/subscription/");
                }
                //window.location.reload();
                // this.name = jsondata.name;
                // this.email = jsondata.email;
                

            }
            else{
                alert(json.Message);
                window.location.assign("https://agri-data.cyhg.gov.tw/#/login");
            }
        }
    },
    methods:{
        async Auth(){
            let data = await this.userRequest.post("/API/Line/GetLineOption",{state:"goLine"});
            let jsondata = JSON.parse(data.data);
            if(jsondata.Status){
                let res = JSON.parse(jsondata.Data);
                console.log(res);
                let URL = 'https://access.line.me/oauth2/v2.1/authorize?';
                URL += 'response_type=code';
                
                //channel id
                URL += '&client_id='+res.channel_id; 

                // 與Line Developer Channel設定的一樣就好，驗證完就會經過瀏覽器轉址回來
                URL += '&redirect_uri='+res.authorize_uri;

                // 狀態碼是會從client呼叫端帶到驗證端，再從驗證端帶回
                // 因此應該可以作為一個亂數卡控確保是自已丟出去的交易碼
                URL += '&state='+res.state;   
                
                //要求存取的範圍
                URL += '&scope=openid%20profile';

                window.location.href = URL;
                return window.location.href;
            }
        }
    }
}
</script>